const authenticationSchema = {
  loggedin: false,
  token: false,
  expired: false,
};

export default authenticationSchema;
